import { Component, OnInit } from '@angular/core';
import { Behfa_Interface } from 'src/app/Interface/Behfa_Interface';
import { BehfaService } from 'src/app/Service/Behfa/Behfa.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-BehfaList',
  templateUrl: './BehfaList.component.html',
  styleUrls: ['./BehfaList.component.scss']
})
export class BehfaListComponent implements OnInit {

  Token:String=""
  BaseUrl=environment.BaseUrl

  constructor(
    private Behfa_Service:BehfaService,
    private Nav_Service:NavService,
  ) { }

  DataList_Behfa:Array<Behfa_Interface>=[]

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,1112).subscribe(
      data=>{
        this.ReadData_Behfa()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }

  ReadData_Behfa(){
    this.Behfa_Service.GetRecord(this.Token).subscribe(
      data=>{
        this.DataList_Behfa=data
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }
}
